<!-- Positive / negative feedback bottom sheet (PCSA-13171). Docked to the panel
     bottom; the response stays visible above. Exact copy + layout per Figma.
     Each <form> binds [formGroup] so (ngSubmit) is Angular's directive output
     (it calls preventDefault) — otherwise the type="submit" button would trigger
     a native form submission and reload the page. -->
<div *ngIf="isOpen" class="orbi-feedback-sheet" role="dialog" [attr.aria-label]="title">
  <header class="orbi-feedback-sheet__header">
    <h3 class="orbi-feedback-sheet__title">{{ title }}</h3>
    <button type="button" class="orbi-feedback-sheet__close material-icons-round" aria-label="Close feedback" (click)="close()">
      close
    </button>
  </header>

  <!-- Positive: optional comment -->
  <form *ngIf="isPositive" class="orbi-feedback-sheet__body" [formGroup]="positiveForm" (ngSubmit)="submit()">
    <label class="orbi-feedback-sheet__label" for="orbi-fb-pos-comment">
      What did you like about this response? <span class="orbi-feedback-sheet__optional">(Optional)</span>
    </label>
    <textarea id="orbi-fb-pos-comment" class="orbi-feedback-sheet__comment" rows="3" formControlName="comment"></textarea>
    <p class="orbi-feedback-sheet__helper">We use this to improve our AI Features</p>

    <!-- Submission failure (PCSA-13473): the sheet stays open with the comment
         intact, so pressing Submit again is a real retry. -->
    <p *ngIf="submitFailed" class="orbi-feedback-sheet__error" role="alert">
      <span class="orbi-feedback-sheet__error-icon material-icons-round" aria-hidden="true">error</span>
      We couldn't submit your feedback. Please try again.
    </p>

    <!-- Shared SMALL pills (design review, "Anatomy of these buttons": "make sure
         all buttons are SMALL (bootstrap)" / "minimum 128px A11Y"). These were
         hand-rolled <button>s at 40px with a 16px label — bootstrap's DEFAULT
         geometry, one step above SMALL — so they sat taller than every other
         control the agent draws; `ui-button`'s `minWidth` default is the 128px the
         note asks for. Submit stays `type="submit"` so the form's own (ngSubmit)
         still fires it: the shared component renders its <button> inside this
         <form>, so native submission is unchanged. -->
    <div class="orbi-feedback-sheet__actions">
      <ui-button
        class="orbi-feedback-sheet__btn orbi-feedback-sheet__btn--cancel"
        buttonText="Cancel"
        rank="secondary"
        size="small"
        (handleClick)="close()"
      ></ui-button>
      <ui-button
        class="orbi-feedback-sheet__btn orbi-feedback-sheet__btn--submit"
        [buttonText]="submitLabel"
        rank="primary"
        size="small"
        buttonType="submit"
        [buttonDisabled]="submitting"
      ></ui-button>
    </div>
  </form>

  <!-- Negative: >=1 issue category + required explanation -->
  <form *ngIf="!isPositive" class="orbi-feedback-sheet__body" [formGroup]="negativeForm" (ngSubmit)="submit()">
    <p class="orbi-feedback-sheet__label">What didn't you like about this response?</p>
    <p class="orbi-feedback-sheet__subtext">Select at least one issue.</p>

    <p *ngIf="showReasonError" class="orbi-feedback-sheet__error" role="alert">
      <span class="orbi-feedback-sheet__error-icon material-icons-round" aria-hidden="true">error</span>
      Select at least one issue
    </p>

    <label *ngFor="let reason of reasons" class="orbi-feedback-sheet__reason">
      <input type="checkbox" [checked]="isReasonSelected(reason.value)" (change)="toggleReason(reason.value)" />
      <span
        >{{ reason.label }}<span *ngIf="reason.value === OtherReason" class="orbi-feedback-sheet__optional"> (Please explain.)</span></span
      >
    </label>

    <label class="orbi-feedback-sheet__label orbi-feedback-sheet__label--tell" for="orbi-fb-neg-comment"> Tell us more: </label>
    <textarea
      id="orbi-fb-neg-comment"
      class="orbi-feedback-sheet__comment"
      [class.orbi-feedback-sheet__comment--error]="showCommentError"
      rows="3"
      formControlName="comment"
    ></textarea>
    <p *ngIf="showCommentError" class="orbi-feedback-sheet__error" role="alert">
      <span class="orbi-feedback-sheet__error-icon material-icons-round" aria-hidden="true">error</span>
      An explanation is required
    </p>

    <!-- Submission failure (PCSA-13473) — see the positive form. It matters most
         here: the categories and the required explanation are still filled in, so
         the retry costs one press instead of re-entering the whole form. -->
    <p *ngIf="submitFailed" class="orbi-feedback-sheet__error" role="alert">
      <span class="orbi-feedback-sheet__error-icon material-icons-round" aria-hidden="true">error</span>
      We couldn't submit your feedback. Please try again.
    </p>

    <!-- Same shared SMALL pills as the positive form above. -->
    <div class="orbi-feedback-sheet__actions">
      <ui-button
        class="orbi-feedback-sheet__btn orbi-feedback-sheet__btn--cancel"
        buttonText="Cancel"
        rank="secondary"
        size="small"
        (handleClick)="close()"
      ></ui-button>
      <ui-button
        class="orbi-feedback-sheet__btn orbi-feedback-sheet__btn--submit"
        [buttonText]="submitLabel"
        rank="primary"
        size="small"
        buttonType="submit"
        [buttonDisabled]="submitting"
      ></ui-button>
    </div>
  </form>
</div>
